<template>
  <div class="order">
    <div class="btn_box_private">
      <el-popconfirm
        @onConfirm="batch()"
        :cancel-button-text="$t('MySpace.tip.cancel')"
        :confirm-button-text="$t('MySpace.tip.confirm')"
        :title="$t('MySpace.tip.deleteSelectOrder')"
      >
        <el-button class="btn_private" slot="reference">
          {{ $t("MySpace.batchDelete") }}</el-button
        >
      </el-popconfirm>
    </div>
    <div class="table_b">
      <el-table
        :data="orderData"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="35"></el-table-column>
        <el-table-column
          prop="orderId"
          :label="$t('MySpace.orderNum')"
        ></el-table-column>
        <!-- <el-table-column prop="productName" label="数据集名称"> </el-table-column> -->
        <el-table-column prop :label="$t('MySpace.orderStatus')">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.status == 0
                  ? $t("MySpace.inPreparation")
                  : $t("MySpace.Finish")
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="dataSize"
          :label="$t('MySpace.dataSize')"
        ></el-table-column>
        <el-table-column
          prop="orderTime"
          :label="$t('MySpace.orderTime')"
        ></el-table-column>
        <el-table-column fixed="right" :label="$t('MySpace.Operation')">
          <template slot-scope="scope">
            <div class="btn_box_private">
              <el-button
                @click="handleClick(scope.row, 'info')"
                type="text"
                size="small"
                class="btn_private"
                >{{ $t("MySpace.seen") }}</el-button
              >
              <el-popconfirm
                @onConfirm="popconfirmDelete(scope.row)"
                :title="$t('MySpace.tip.deleteTheOrder')"
                :cancel-button-text="$t('MySpace.tip.cancel')"
                :confirm-button-text="$t('MySpace.tip.confirm')"
              >
                <el-button class="btn_private" slot="reference">{{
                  $t("MySpace.tip.delete")
                }}</el-button>
              </el-popconfirm>
              <!-- <el-button
                @click="handleClick(scope.row, 'delete')"
                type="text"
                size="small"
                class="btn_private"
                >{{ $t("MySpace.delete") }}</el-button
              > -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        :title="$t('MySpace.tip.order')"
        :visible.sync="showOrderDialog"
        width="80%"
        :before-close="handleClose"
      >
        <div class="order_info" v-if='ftpInfo'>
          <div class="order_info_header">
            <div class="text">{{ $t("MySpace.tip.projectName") }}：{{ftpInfo.order.taskName}}</div>
            <div class="text">{{ $t("MySpace.tip.orderNum") }}：{{ftpInfo.order.orderId}}</div>
            <div class="text">{{ $t("MySpace.tip.status") }}：{{ftpInfo.order.status==1?$t('MySpace.Finish'):$t('MySpace.inPreparation')}}</div>

            <div class="text">{{ $t("MySpace.tip.adrees") }}：{{ftpInfo.ftpInfo.address}}</div>
            <div class="text">{{ $t("MySpace.tip.FTPaccount") }}：{{ftpInfo.ftpInfo.username}}</div>
            <div class="text">{{ $t("MySpace.tip.FTPpassword") }}：{{ftpInfo.ftpInfo.password}}</div>
            <div class="text_note">
              {{ $t("MySpace.tip.applicationNotes") }}：{{ftpInfo.order.appNote}}
            </div>
          </div>

          <div>
            <el-table :data="dataInfoArray" style="width: 100%">
              <el-table-column
                prop="productName"
                :label="$t('MySpace.ftp.dataSatName')"
              ></el-table-column>

              <el-table-column
                prop="dataId"
                :label="$t('MySpace.ftp.dataId')"
              ></el-table-column>
              <el-table-column
                prop="createTime"
                :label="$t('MySpace.ftp.createTime')"
              ></el-table-column>
            </el-table>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="showOrderDialog = false">{{
            $t("MySpace.tip.cancel")
          }}</el-button>
          <el-button type="primary" @click="showOrderDialog = false">{{
            $t("MySpace.tip.confirm")
          }}</el-button>
        </span>
      </el-dialog>
      <div class="footer_page" v-log="{ params: { clickName: '下载数据' } }">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { orderList, deleteOrder, orderInfo ,ftpInfo} from "@/axios/private.js";
import bus from "@/bus";
export default {
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      total: null,
      orderData: [],
      collectionData: [],
      showOrderDialog: false,
      dataInfoArray: [],
      ftpInfo:null
    };
  },
  methods: {
    //   批量处理
    batch() {
      var userVerifyLogin = this.verifyLogin();

      if (!userVerifyLogin) {
        // 提示用户登录
        bus.$emit("LoginDialogEmit");
        return;
      }
      if (this.collectionData.length == 0) {
        this.$message({
          message: this.$t("MySpace.tip.seleteDataEntry"),
          duration: 1000,
        });
        return;
      }
      var ids = [];
      console.log(this.collectionData);
      this.collectionData.forEach((item) => {
        ids.push(item.orderId);
      });
      var idsStr = ids.join(",");
      this.deleteOrderFun(idsStr).then((res) => {
        this.orderListFun().then((res) => {
          this.orderData = res.data.data.records;
        });
      });
    },
    popconfirmDelete(tab) {
      this.deleteOrderFun(tab.orderId).then((res) => {
        this.orderListFun().then((res) => {
          this.orderData = res.data.data.records;
        });
      });
    },
    // 校验是否登录
    verifyLogin() {
      return localStorage.getItem("token") && localStorage.getItem("loginName");
    },
    // 获取订单列表
    async orderListFun() {
      var param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      return await orderList(param);
    },
    async deleteOrderFun(data) {
      return await deleteOrder(data);
    },
    async orderInfo(orderId) {
      return await orderInfo(orderId);
    },
    handleClick(tab, type) {
      console.log(tab, type);
      var userVerifyLogin = this.verifyLogin();

      if (!userVerifyLogin) {
        // 提示用户登录
        bus.$emit("LoginDialogEmit");
        return;
      }
      if (type == "delete") {
        this.deleteOrderFun(tab.orderId).then((res) => {
          this.orderListFun().then((res) => {
            this.orderData = res.data.data.records;
          });
        });
      } else {
        // alert("chakan");
        this.orderInfo(tab.orderId).then((res) => {      
          this.dataInfoArray = res.data.data;
          this.showOrderDialog = true;
          this.ftpInfoFun(tab.orderId).then((res)=>{
            console.log(res.data.data)
            this.ftpInfo = res.data.data
          })
        });
      }
    },
    async ftpInfoFun(orderId){
      return await ftpInfo(orderId)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.orderListFun().then((res) => {
        this.orderData = res.data.data.records;
      });
    },

    handleSelectionChange(obj) {
      this.collectionData = obj;
    },
  },
  mounted() {
    bus.$on("updateOrder", () => {
      this.orderListFun().then((res) => {
        this.orderData = res.data.data.records;
        this.total = res.data.data.total;
      });
    });
    this.orderListFun().then((res) => {
      this.orderData = res.data.data.records;
      this.total = res.data.data.total;
    });
  },
};
</script>

<style lang="scss">
.order_info {
  display: flex;
  flex-direction: column;
  .order_info_header {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .text_note {
      width: 100%;
      margin-bottom: 8px;
    }
    .text {
      margin-bottom: 8px;
      width: 33%;
      display: inline-block;
    }
  }
}
.order {
  .el-dialog__body {
    padding: 10px 20px;
  }
  margin-bottom: 10px;
  th {
    background: #e9f7fe;
  }
  .table_b {
    margin-top: 20px;
  }
  .btn_box_private {
    display: flex;
    width: fit-content;
    margin: 10px 0;
  }
  .btn_private {
    padding: 4px 20px;
    margin-right: 4px;
    border: 1px solid #0a97d9;
    border-radius: 20px;
    color: #0a97d9;
    cursor: pointer;
    font-size: 14px;
    &:hover {
      background: #0a97d9;
      color: #fff;
    }
  }
  .footer_page {
    text-align: center;
    margin: 20px auto;
  }
}
</style>